<section class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <section class="rs-es-first-section">
      <div class="row">
        <div class="columns small-12">
          <div class="small-only-text-center">
            <div
              class="panel rs-inline-block rs-wd-s30 rs-wd-m31 rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
            ></div>
          </div>

          <div class="small-only-text-center">
            <div>
              <div
                class="panel rs-inline-block rs-wd-s14 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
          </div>

          <div class="panel rs-panel-big clearfix">
            <div
              class="rs-flex-row rs-flex-collapse rs-flex-middle-medium rs-flex-dir-col-small-only"
            >
              <div class="rs-flex-columns">
                <div class="small-only-text-center">
                  <div
                    class="panel rs-inline-block rs-wd-s8 rs-h-s3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
              </div>
              <div class="rs-flex-columns">
                <div class="small-only-text-center">
                  <div
                    class="panel rs-inline-block rs-wd-s14 rs-h-s2 rs-no-padding rs-margin1 rs-no-margin-top rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="columns small-12 medium-6">
                <div class="panel rs-bg-grey2 clearfix">
                  <div class="small-only-text-center">
                    <div
                      class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                    ></div>
                  </div>

                  <div class="rs-flex-row rs-flex-bottom">
                    <div class="rs-flex-column">
                      <div
                        class="panel rs-wd-s10 rs-wd-m14 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                    <div class="rs-flex-column rs-flex-shrink">
                      <div
                        class="panel rs-wd-s8 rs-wd-m12 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                  <div
                    class="panel rs-maxw rs-h-s1 rs-h-m2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                  ></div>
                  <div class="rs-flex-row rs-flex-bottom">
                    <div class="rs-flex-column">
                      <div
                        class="panel rs-wd-s10 rs-wd-m14 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                    <div class="rs-flex-column rs-flex-shrink">
                      <div
                        class="panel rs-wd-s8 rs-wd-m12 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                  <div
                    class="panel rs-maxw rs-h-s1 rs-h-m2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
              </div>
            </div>

            <div class="rs-me"></div>

            <div class="small-only-text-center">
              <div
                class="panel rs-inline-block rs-wd-s6 rs-wd-m10 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>

            <div class="panel rs-bg-grey1 clearfix">
              <div
                class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
              ></div>
              <div
                class="panel rs-maxw rs-h-s2 rs-wd-m48 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
              ></div>
              <div
                class="panel rs-wd-s15 rs-wd-m22 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
              ></div>
              <div
                class="panel rs-wd-s12 rs-wd-m18 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
              ></div>
              <div
                class="panel rs-maxw rs-wd-m55 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
              ></div>
              <div
                class="panel rs-maxw rs-wd-m55 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
              ></div>
              <div
                class="panel rs-maxw rs-wd-m55 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
              ></div>
              <div
                class="panel rs-maxw rs-wd-m55 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
              ></div>
              <div
                class="panel rs-maxw rs-wd-m55 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
              ></div>
              <div
                class="panel rs-maxw rs-wd-m55 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
              ></div>
              <div
                class="panel rs-maxw rs-wd-m55 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
              ></div>
              <div
                class="panel rs-maxw rs-wd-m55 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
              ></div>
              <div
                class="panel rs-maxw rs-wd-m55 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
              ></div>
              <div
                class="panel rs-maxw rs-wd-m55 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
              ></div>

              <div
                class="panel rs-wd-s9 rs-wd-m13 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
              ></div>
              <div
                class="panel rs-wd-s9 rs-wd-m13 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
          </div>

          <div class="text-center">
            <div>
              <div
                class="panel rs-inline-block rs-wd-s17 rs-h-s6 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
            <div class="hide-for-medium-up">
              <div
                class="panel rs-inline-block rs-wd-s30 rs-wd-m44 rs-h-s2 rs-no-padding rs-no-margin rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
            <div>
              <div
                class="panel rs-inline-block rs-wd-s30 rs-wd-m44 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
          </div>

          <div class="rs-le2"></div>
        </div>
      </div>
    </section>
  </main>
</section>
